import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const LEVELS = ['Newbie', 'Beginner', 'Intermediate', 'Advanced', 'Master'];
export const SORT_OPTIONS = [
  { value: 'name', label: 'Name A→Z' },
  { value: 'lastUpdate', label: 'Last Updated' },
  { value: 'ai', label: 'AI Order' },
];

function parseSearch(search) {
  const params = new URLSearchParams(search);
  const rawType = params.get('type');
  const type = rawType === 'text' ? 'text' : rawType === 'deck' ? 'deck' : 'all';
  const level = params.get('level') || null; // single level or null
  const title = params.get('title') || params.get('search') || '';
  const rawPremium = params.get('premium');
  const premiumFilter = rawPremium === 'true' ? 'premium' : rawPremium === 'false' ? 'free' : 'all';
  const newContent = params.get('newContent') === 'true';
  const sort = params.get('sort') || 'name';
  const available = params.get('available') || 'all'; // 'all' | 'active' | 'inactive'
  return { type, level, title, premiumFilter, newContent, sort, available };
}

function buildSearch({ type, level, title, premiumFilter, newContent, sort, available }) {
  const params = new URLSearchParams();
  if (type && type !== 'all') params.set('type', type);
  if (level) params.set('level', level);
  if (title) params.set('title', title);
  if (premiumFilter === 'premium') params.set('premium', 'true');
  if (premiumFilter === 'free') params.set('premium', 'false');
  if (newContent) params.set('newContent', 'true');
  if (sort && sort !== 'name') params.set('sort', sort);
  if (available && available !== 'all') params.set('available', available);
  return params.toString();
}

export function useCatalogFilters() {
  const location = useLocation();
  const history = useHistory();

  const filters = useMemo(() => parseSearch(location.search), [location.search]);

  const setFilters = useCallback(
    (updates) => {
      const next = { ...filters, ...updates };
      const search = buildSearch(next);
      history.replace({ pathname: location.pathname, search: search ? `?${search}` : '' });
    },
    [filters, history, location.pathname]
  );

  const resetFilters = useCallback(() => {
    history.replace({ pathname: location.pathname, search: '' });
  }, [history, location.pathname]);

  const catalogParams = useMemo(
    () => ({
      type: filters.type !== 'all' ? filters.type : undefined,
      title: filters.title || undefined,
      level: filters.level || undefined,
      premium:
        filters.premiumFilter === 'premium'
          ? true
          : filters.premiumFilter === 'free'
          ? false
          : undefined,
      newContent: filters.newContent || undefined,
      order: filters.sort === 'ai' || !filters.sort ? 'name' : filters.sort,
      available:
        filters.available === 'active'
          ? true
          : filters.available === 'inactive'
          ? false
          : undefined,
    }),
    [filters]
  );

  return {
    filters,
    setFilters,
    resetFilters,
    catalogParams,
    LEVELS,
  };
}
